import {
//   Box,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Clock8 } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OpenCalendarArrow } from "./CalendarCard.style";

export function SelectTime({
  disabled,
  onChange,
  options,
  value,
  type
}: {
    disabled: boolean
    onChange: (event: SelectChangeEvent) => void
    options: Array<{timeOption: string, bookable:boolean, disabled: boolean}>
    value: string,
    type:string
}) {

  const { t } = useTranslation();
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Select
      aria-label={ type === "from" ? t("select_start_time"): t("select_end_time") }
      disabled={ disabled }
      value={ value }
      onChange={ onChange }
      onOpen={ () => setIsOpen(true) }
      onClose={ () => setIsOpen(false) }
      IconComponent={ (props) => (
        <OpenCalendarArrow
          isOpen={ isOpen }
          { ...props }
        />
      ) }
      startAdornment={
        <InputAdornment position="start">
          <Clock8 size="1rem" color={ theme.customColors.exploreCardText } />
        </InputAdornment>
      }
      sx={ {
        backgroundColor: theme.customColors.drawerWidgetBg,
        borderRadius: "0.2rem",
        border:"2px solid " + theme.customColors.border,
        color: theme.customColors.exploreCardText,
        fontSize: "14px",
        height: "40px",
        lineHeight: "0",
        paddingLeft: "16px",
        "svg":{
          stroke: theme.customColors.exploreCardText
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none"
        },
        ".MuiSelect-select":{
          minHeight:"unset"
        },
        "&.Mui-focused": {
          outline: `2px solid ${theme.customColors.headerIcon}`,
          outlineOffset: "2px"
        }
      } }
      MenuProps={ {
        className:"from-select-menu",
        sx: {
          "& .MuiMenu-paper": {
            backgroundColor: theme.customColors.drawerWidgetBg,
            "& .MuiMenuItem-root": {
              color: theme.customColors.exploreCardText,
              ":hover":{
                background: theme.customColors.backgroundSecondaryHover
              }
            },
            border: "none",
            borderRadius: "2px",
            // height: "240px",
            margin: "3px 0",
            overflow: "hidden",
            padding: "4px 4px 4px 16px",

            "& ul.MuiList-root": {
              height: "240px",
              overflowY: "auto",

              "::-webkit-scrollbar": {
                width: "4px"
              },
              "::-webkit-scrollbar-thumb":{
                backgroundColor: theme.customColors.systemDisabled,
                borderRadius: "8px"
              }
            }
          },
          "& .MuiMenuItem-root.Mui-focusVisible": {
            outline: `2px solid ${theme.customColors.headerIcon}`,
            outlineOffset: "-2px"
          }
        }
      } }
    >
      <MenuItem
        tabIndex={ isOpen ? 0 : -1 }
        aria-hidden={ isOpen ? undefined : "true" }
        key={ "from-select" }
        value={ value }
        disabled={ true }
        sx={ { display: "none" } }
      >
        { "select" }
      </MenuItem>
      {
        options.map((option) => (
          <MenuItem
            tabIndex={ isOpen ? 0 : -1 }
            aria-hidden={ isOpen ? undefined : "true" }
            key={ `from-${option.timeOption}` }
            value={ option.timeOption }
            disabled={ option.disabled }
            sx={ {
              color: theme.customColors.textInput,
              fontSize: "14px",
              lineHeight: "18px",
              padding: "4px 0"
            } }
          >
            { option.timeOption }
          </MenuItem>
        ))
      }
    </Select>
  );
}
